import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { YachtsFiltersFormT } from "./yachts-filters.schema";
import { Checkbox } from "@/src/components/ui/checkbox";

const types = [
  {
    id: "bareboat",
    label: "Bareboat",
  },
  {
    id: "skippered",
    label: "Skippered",
  },
  {
    id: "crewed",
    label: "Crewed",
  },
] as const;

export const CharterTypes = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Charter types</h3>
      <FormField<YachtsFiltersFormT, "charterType">
        name="charterType"
        render={() => (
          <FormItem>
            {types.map((item) => (
              <FormField
                key={item.id}
                name="charterType"
                render={({ field }) => {
                  return (
                    <FormItem key={item.id} className="flex flex-row items-start space-x-3 space-y-0">
                      <FormControl>
                        <Checkbox
                          className="w-6 h-6"
                          checked={field.value?.includes(item.id)}
                          onCheckedChange={(checked) => {
                            return checked
                              ? field.onChange([...field.value, item.id])
                              : field.onChange(field.value?.filter((value: string) => value !== item.id));
                          }}
                        />
                      </FormControl>
                      <FormLabel className="font-normal text-base leading-6">{item.label}</FormLabel>
                    </FormItem>
                  );
                }}
              />
            ))}
          </FormItem>
        )}
      />
    </div>
  );
};
